import type { AnchorHTMLAttributes } from 'react';
import { ExternalLink } from './ExternalLink';

// Anchor renderer for markdown/Prose-rendered content — the react-markdown `a`
// slot. Two concerns beyond ExternalLink itself:
//
//   - react-markdown passes the hast `node` to component overrides; it must not
//     spread onto the DOM element, so it's stripped here.
//   - A link whose href the sanitizer removed (disallowed protocol) arrives
//     with no href; there's nothing to navigate to, so it falls back to the
//     plain link text.
//
// Everything else routes through ExternalLink, which decides internal-vs-
// external from the href: internal Connect destinations navigate in the SAME
// tab via the client router, external links open a new tab behind the confirm
// interstitial. `rest` may carry target/rel injected by rehype-external-links
// upstream — ExternalLink drops them for internal links and re-applies its own
// for external ones, so they're harmless either way.
export function ContentAnchor({
  href,
  children,
  node: _node,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { node?: unknown }) {
  if (href === undefined) return <>{children}</>;
  return (
    <ExternalLink href={href} {...rest}>
      {children}
    </ExternalLink>
  );
}
